import PersonnelNavItem from '../Personnel/PersonnelNavItem';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDeviceRequestBadges, CountBadge } from '../DeviceRequests/deviceRequestApi';
import { SidebarLogo, SidebarNavList } from '../common/SidebarNav';
import { homeForRole } from '../route/RoleRoute';
import { BillingGapsBadge } from '../HR/BillingGapsWorklist';
import '../HR/hrSidebar.css';
import BpGuide from '../common/BpGuide';


export const ADMIN_DASHBOARD = { to: '/adminDashboard', icon: 'fas fa-home', label: 'My Dashboard' };

// Read-only roles (Billing / Accounting) only see the screens their permissions allow.
const ACCOUNTING = { to: '/accounting/monthly', icon: 'fas fa-calculator', label: 'Accounting' };
const BILLING_CODES = { to: '/billing/codes', icon: 'fas fa-list-ol', label: 'Billing — Suggested codes' };
const MONTHLY = { to: '/report/monthly', icon: 'bx bxs-file-pdf', label: 'Monthly RPM Reports' };
const INSURANCE_MISSING = { to: '/insurance/missing', icon: 'fas fa-id-card', label: 'Insurance missing' };
const PRACTICE_SETTINGS = { to: '/accounting/practice-settings', icon: 'fas fa-sliders-h', label: 'Practice settings' };
export const READ_ONLY_MENU = {
    billing: [BILLING_CODES, ACCOUNTING, MONTHLY, INSURANCE_MISSING],
    accounting: [ACCOUNTING, PRACTICE_SETTINGS, MONTHLY, INSURANCE_MISSING],
};

export const readOnlyDashboard = (role) => {
    const items = READ_ONLY_MENU[role] || [];
    return items.find((it) => it.to === homeForRole(role)) || items[0];
};

const ReadOnlySidebar = ({ role, items }) => {
    const dashboard = readOnlyDashboard(role);
    return (
    <div className="sidebar hr-white-sidebar">
        <SidebarLogo />
        <SidebarNavList dashboard={dashboard}>
            {items.filter((it) => it !== dashboard).map((it) => (
                <li className="nav_link" key={it.to}>
                    <NavLink to={it.to} activeClassName="link-name-active">
                        <i className={it.icon} style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title={it.label}>{it.label}</span>
                    </NavLink>
                </li>
            ))}
        </SidebarNavList>
    </div>
    );
};

const Sidebar = () => {
    const { user } = useSelector(state => state.auth);
    const isSuperAdmin = user?.role === 'admin';
    const drBadges = useDeviceRequestBadges(!READ_ONLY_MENU[user?.role]);
    if (READ_ONLY_MENU[user?.role]) return <ReadOnlySidebar role={user.role} items={READ_ONLY_MENU[user.role]} />;

    return (
        <>
            <div className="sidebar hr-white-sidebar">
            <SidebarLogo />

            <SidebarNavList dashboard={ADMIN_DASHBOARD}>
                <li className="nav_link">
                    <NavLink key="rpmPatients" to="/patients" activeClassName="link-name-active">
                    <i className="fas fa-user-injured" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="RPM Patients">RPM Patients</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="ccmPatients" to="/CCM/Patients" 
                     activeClassName="link-name-active">
                    <i className="fas fa-hospital-user" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="CCM Patients">CCM Patients</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="doctors" to="/doctors" activeClassName="link-name-active">
                    <i className="fas fa-user-md" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Manage Providers">Manage Providers</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="hr" to="/hrlist" activeClassName="link-name-active">
                    <i className="fas fa-users" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                    <span className="link_name" title="Nurse Resources">Nurse Resources</span>
                    </NavLink>
                </li>

                <PersonnelNavItem />

                <li className="nav_link">
                    <NavLink to="/enrollment/patients" activeClassName="link-name-active">
                        <i className="fas fa-user-plus"></i>
                        <span className="link_name" title="Program Enrollment">Program Enrollment</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="inventory" to="/devices" activeClassName="link-name-active">
                    <i className="fas fa-weight" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                    <span className="link_name" title="Inventory Management">Inventory Management</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="deviceAssign" to="/devices/assign" activeClassName="link-name-active">
                    <i className="fas fa-barcode" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                    <span className="link_name" title="Assign / Unassign Devices">Assign / Unassign Devices</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="deviceRequests" exact to="/device-requests" activeClassName="link-name-active">
                    <i className="fas fa-clipboard-list" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                    <span className="link_name" title="Device Requests">Device Requests<CountBadge n={drBadges.submitted} bg="primary" title="New submitted" /><CountBadge n={drBadges.approvedUnsent} bg="warning" title="Approved, not sent" /></span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="insuranceMissing" to="/insurance/missing" activeClassName="link-name-active">
                    <i className="fas fa-id-card" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                    <span className="link_name" title="Insurance missing">Insurance missing</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="dailyEnrollmentRequest" to="/device-requests/daily" activeClassName="link-name-active">
                    <i className="fas fa-paper-plane" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                    <span className="link_name" title="Daily Enrollment Request">Daily Enrollment Request</span>
                    </NavLink>
                </li>

                {isSuperAdmin && (
                <li className="nav_link">
                    <NavLink key="ecDeviceRequests" to="/enrollment/device-requests" activeClassName="link-name-active">
                    <i className="fas fa-box-open" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                    <span className="link_name" title="EC Pending Device Requests">EC Pending Requests<CountBadge n={drBadges.ecPending} title="Pending at EC" /></span>
                    </NavLink>
                </li>
                )}

                <li className="nav_link">
                    <NavLink key="enrollmentCoordinators" to="/enrollment-coordinators" activeClassName="link-name-active">
                    <i className="fas fa-id-badge" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                    <span className="link_name" title="Enrollment Coordinators">Enrollment Coordinators</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="'managelogs'" to="/logs" activeClassName="link-name-active">
                    <i className='fas fa-book-open' style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Manage Logs">Manage Logs</span>
                    </NavLink>
                </li>

                {isSuperAdmin && (

                <li className="nav_link">
                    <NavLink key="credentials" to="/credentials" activeClassName="link-name-active">
                        <i className='fas fa-key' style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Hard Reset Password">Hard Reset Password</span>
                    </NavLink>
                </li>

                )}

                <hr className='white-hr'/>

                <li className="nav_link">
                    <NavLink key="timereport" to="/Admin/Report/RPM" activeClassName="link-name-active">
                        <i className='fas fa-history' style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Time Report">Time Report</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="ksandasd" to="/report/financialReport" activeClassName="link-name-active">
                    <i className='fas fa-funnel-dollar' style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Financial Report">Financial Report</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="telemetarydatareport" to="/report/telemetary" activeClassName="link-name-active">
                    <i className='fas fa-heart' style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Telemetary Data Report">Telemetary Data Report</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="billingCodes" to="/billing/codes" activeClassName="link-name-active">
                    <i className='fas fa-list-ol' style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Billing — Suggested codes">Billing — Suggested codes</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="accountingMonthly" to="/accounting/monthly" activeClassName="link-name-active">
                    <i className='fas fa-calculator' style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Accounting">Accounting</span>
                    </NavLink>
                </li>

                {user?.role === 'admin' && (
                <li className="nav_link">
                    <NavLink key="practiceSettings" to="/accounting/practice-settings" activeClassName="link-name-active">
                    <i className='fas fa-sliders-h' style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Practice settings">Practice settings</span>
                    </NavLink>
                </li>
                )}

                <li className="nav_link">
                    <NavLink key="monthlyreport" to="/report/monthly" activeClassName="link-name-active">
                    <i className='bx bxs-file-pdf' style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Monthly RPM Reports">Monthly RPM Reports</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="billingReport" to="/report/billing" activeClassName="link-name-active">
                    <i className='fas fa-file-invoice-dollar' style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Billing Report">Billing Report</span><BillingGapsBadge style={{ marginLeft: 6 }} />
                    </NavLink>
<NavLink key="nurseBonus" to="/billing/nurse-bonus" activeClassName="link-name-active">
                    <i className='fas fa-file-invoice-dollar' style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Nurse Bonus">Nurse Bonus</span>
                    </NavLink>
<NavLink key="duplicates" to="/billing/duplicates" activeClassName="link-name-active">
                    <i className='fas fa-file-invoice-dollar' style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Duplicate Review">Duplicate Review</span>
                    </NavLink>
<NavLink key="enrollmentWarnings" to="/billing/enrollment-warnings" activeClassName="link-name-active">
                    <i className='fas fa-file-invoice-dollar' style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Enrollment Warnings">Enrollment Warnings</span>
                    </NavLink>
<NavLink key="payers" to="/billing/payers" activeClassName="link-name-active">
                    <i className='fas fa-file-invoice-dollar' style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Payers">Payers</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="nursesPerformance" to="/performance" activeClassName="link-name-active">
                    <i className='fas fa-chart-line' style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Nurses Performance">Nurses Performance <span className="text-white newSpan">New</span></span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="ndjaiusd" to="/Admin/Report/InitialMonth" activeClassName="link-name-active">
                        <i className="fas fa-stream" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Initial Month Report">Initial Month Report</span>
                    </NavLink>
                </li>
                <BpGuide />
            </SidebarNavList>
        </div>    
        </>
    )
}

export default Sidebar;
